import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { rem } from 'polished'
import EVENTS from '../../utils/events'
import { matchUrlToActiveSection } from '../../utils/location'

import typography from '../../utils/typography'
import IconArrowDown from '../../vectors/IconArrowDown'
import { Grid } from '../../utils/style'

/*************************
  STYLES: More link
**************************/
const More = styled.div`
  position: relative;
  z-index: 3;
  float: left;

  a {
    text-decoration: none;
    text-transform: uppercase;
    font-size: ${rem('14.5px')};
    font-weight: 600;
    color: ${(props) => props.theme.colors.grey_light};
    opacity: 0.6;
    display: block;
    padding: ${typography.rhythm(0.4)} 32px ${typography.rhythm(0.4)} 15px;
    line-height: 1;
    transition: opacity 0.3s ${(props) => props.theme.ease.ease_out_expo},
      color 0.3s ${(props) => props.theme.ease.ease_out_expo};

    &:hover {
      opacity: 0.6;
    }
  }

  a.active {
    opacity: 1;
    color: ${(props) => props.theme.colors.blue};
  }
`

const Menu = styled.div`
  position: absolute;
  z-index: 3;
  top: 100%;
  left: 100%;
  float: left;
  background: white;
  border-top: 5px ${(props) => props.theme.colors.blue} solid;
  box-shadow: -2px 25px 81px 2.3px rgba(102, 102, 102, 0.25),
    1px 4px 8px 0 rgba(0, 0, 0, 0.15);

  a {
    border-bottom: 1px rgba(154, 163, 179, 0.15) solid;
    opacity: 1;
  }

  a:hover {
    a {
      will-change: color, opacity;
    }
  }

  a:last-child {
    border-bottom: none;
  }
`

/*************************
  STYLES: Drop-down
**************************/
const navigationlinkStyle = `
    text-decoration: none;
    text-transform: uppercase;
    font-size: ${rem('14.5px')};
    font-weight: 600;
    letter-spacing: 0.12em;
    opacity: 0.6;
    display: block;
    &:hover {
      opacity: 1;
    }
  }`

const MoreDropDown = styled(Grid)`
  vertical-align: baseline;
  position: relative;
  z-index: 3;
  border-bottom: 5px white solid;
  padding-left: 12px;
  padding-right: 10px;

  > a {
    padding-top: ${typography.rhythm(0.1)};
    padding-bottom: ${typography.rhythm(0.4)};
  }

  &.closed > .more__section-found,
  &.open > .more__section-found {
    text-decoration: none;
    color: ${(props) => props.theme.colors.blue} !important;
    opacity: 1;

    &:hover {
      color: ${(props) => props.theme.colors.grey};
    }

    svg {
      transform: rotate(-90deg);
      path {
        fill: ${(props) => props.theme.colors.blue};
      }
    }
  }

  .more__menu {
    pointer-events: none;
    transition: transform 0.4s ${(props) => props.theme.ease.ease_out_expo},
      opacity 0.2s ${(props) => props.theme.ease.ease_out_expo};
    transform: scale(1.02) translate3d(-28%, -4px, 0);
    opacity: 0;
  }

  &:focus .more__menu,
  &:hover .more__menu {
    opacity: 1;
  }

  &.open {
    .more__menu {
      display: block;
      opacity: 1;
      pointer-events: auto;
      transform: scale(1) translate3d(-28%, 2px, 0);

      a:hover {
        opacity: 1;
      }
    }

    > a {
      opacity: 1;

      svg {
        transform: scaleY(-1);

        path {
          opacity: 1;
        }
      }
    }

    > a:hover {
      color: ${(props) => props.theme.colors.grey};
    }
  }

  &.closed {
    > a svg path {
      fill: ${(props) => props.theme.colors.grey_op80};
      opacity: 0.6;
      transition: opacity 0.3s ${(props) => props.theme.ease.ease_out_expo},
        fill 0.3s ${(props) => props.theme.ease.ease_out_expo};
    }
  }

  > a {
    color: ${(props) => props.theme.colors.grey_op65};
    transition: opacity 0.3s ${(props) => props.theme.ease.ease_out_expo},
      color 0.3s ${(props) => props.theme.ease.ease_out_expo};
    ${navigationlinkStyle}
  }
`

class RouterMoreDropDown extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { hidden: true }
    this._hide = this._hide.bind(this)
    this._show = this._show.bind(this)
  }

  _hide() {
    this.setState({ hidden: true })
  }
  _show() {
    this.setState({ hidden: false })
  }
  /*
  componentDidMount () {
    // if (typeof window !== 'undefined') {
    //   window.addEventListener(EVENTS.CONTENT.MORE_DROPDOWN_ON, this._show.bind(this))
    //   window.addEventListener(EVENTS.CONTENT.MORE_DROPDOWN_OFF, this._hide.bind(this))
    // }
    console.log('componentDidMount')
  }

  componentWillUnmount () {
    if (typeof window !== 'undefined') {
      window.removeEventListener(EVENTS.CONTENT.MORE_DROPDOWN_ON, this._show.bind(this))
      window.removeEventListener(EVENTS.CONTENT.MORE_DROPDOWN_OFF, this._hide.bind(this))
    }
  }
*/

  render() {
    const _handleOnClick = (_e) => {
      _e.preventDefault()
      if (typeof window !== 'undefined') {
        if (this.state.hidden) {
          this._show()
          // window.dispatchEvent(new Event(EVENTS.CONTENT.MORE_DROPDOWN_ON))
          window.dispatchEvent(new Event(EVENTS.CONTENT.DIMMER_ON))
        } else {
          this._hide()
          // window.dispatchEvent(new Event(EVENTS.CONTENT.MORE_DROPDOWN_OFF))
          window.dispatchEvent(new Event(EVENTS.CONTENT.DIMMER_OFF))
        }
      }
    }
    const _handleMouseEnter = () => {
      if (this.state.hidden) {
        this._show()
        // window.dispatchEvent(new Event(EVENTS.CONTENT.MORE_DROPDOWN_ON))
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new Event(EVENTS.CONTENT.DIMMER_ON))
        }
      }
    }
    const _handleMouseLeave = () => {
      if (!this.state.hidden) {
        this._hide()
        // window.dispatchEvent(new Event(EVENTS.CONTENT.MORE_DROPDOWN_OFF))
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new Event(EVENTS.CONTENT.DIMMER_OFF))
        }
      }
    }

    const sections = this.props.sections
    const classHidden = this.state.hidden ? 'closed' : 'open'
    const locationPath =
      typeof window !== 'undefined' && !this.props.location
        ? document.location.pathname
        : this.props.location
    const match = matchUrlToActiveSection(sections, locationPath)

    return (
      <MoreDropDown
        id="more-drop-down"
        role="tablist"
        className={classHidden}
        onMouseEnter={_handleMouseEnter}
        onMouseLeave={_handleMouseLeave}
      >
        <Link
          to={`/`}
          id="more-drop-down-link"
          aria-haspopup="true"
          onClick={_handleOnClick}
          className={match.found ? 'more__section-found' : null}
        >
          More <IconArrowDown />
        </Link>

        <More aria-label="submenu">
          <Menu className="more__menu">
            {sections.map((section) => (
              <Link
                key={`morem:${section.slug}:{section.label}`}
                to={`/${section.slug}`}
                activeClassName="active"
                role="tab"
                tabIndex={this.state.hidden ? -1 : 0}
              >
                {section.label}
              </Link>
            ))}
          </Menu>
        </More>
      </MoreDropDown>
    )
  }
}

export default RouterMoreDropDown
